export default [
    {
        component: () => import(/* webpackChunkName: 'ambulatorio-atendimento' */ '@/views/ambulatorio/atendimento/Index'),
        path: 'atendimento',
        redirect: 'atendimento/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-atendimento' */'@/views/ambulatorio/atendimento/List.vue'),
                meta: { keepAlive: true },
                name: 'ambulatorio-atendimento-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'ambulatorio-atendimento' */ '@/views/ambulatorio/atendimento/Form.vue'),
                name: 'ambulatorio-atendimento-create',
                path: 'create/:filaId/:agendamentoId?',
                props: route => ({
                    filaId: parseInt(route.params.filaId),
                    fichaAvaliacao: route.params.fichaAvaliacao,
                    agendamentoId: route.params.agendamentoId ? parseInt(route.params.agendamentoId) : null,
                }),
            },
        ],
    },
]